import { Share2, Linkedin, Mail, MessageCircle, Link2, Check } from "lucide-react";
import { useState } from "react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

const SITE_URL = "https://sycmahg.com";
const SITE_TITLE = "SYCMA Corporate Finance | Investment Banking & M&A Advisory";
const SITE_DESCRIPTION =
  "Firma boutique de banca de inversión para empresas hispanohablantes en Americas y Europa.";

interface ShareButtonProps {
  url?: string;
  title?: string;
  description?: string;
  className?: string;
  variant?: "icon" | "text";
}

export default function ShareButton({
  url = SITE_URL,
  title = SITE_TITLE,
  description = SITE_DESCRIPTION,
  className,
  variant = "icon",
}: ShareButtonProps) {
  const [copied, setCopied] = useState(false);

  const fullUrl = url.startsWith("http") ? url : `${SITE_URL}${url}`;

  const shareLinks = [
    {
      name: "WhatsApp",
      icon: MessageCircle,
      action: () =>
        window.open(
          `https://wa.me/?text=${encodeURIComponent(`${title} ${fullUrl}`)}`,
          "_blank"
        ),
    },
    {
      name: "LinkedIn",
      icon: Linkedin,
      action: () =>
        window.open(
          `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(fullUrl)}`,
          "_blank"
        ),
    },
    {
      name: "X / Twitter",
      icon: Share2,
      action: () =>
        window.open(
          `https://twitter.com/intent/tweet?text=${encodeURIComponent(title)}&url=${encodeURIComponent(fullUrl)}`,
          "_blank"
        ),
    },
    {
      name: "Email",
      icon: Mail,
      action: () =>
        window.open(
          `mailto:?subject=${encodeURIComponent(title)}&body=${encodeURIComponent(`${description}\n\n${fullUrl}`)}`,
          "_self"
        ),
    },
    {
      name: copied ? "¡Copiado!" : "Copiar enlace",
      icon: copied ? Check : Link2,
      action: () => {
        navigator.clipboard.writeText(fullUrl);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
      },
    },
  ];

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size={variant === "icon" ? "icon" : "default"}
          className={cn(
            "text-steel hover:text-gold transition-colors",
            className
          )}
          aria-label="Compartir"
        >
          <Share2 className="h-4 w-4" />
          {variant === "text" && <span className="ml-2">Compartir</span>}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-48">
        {shareLinks.map((link) => (
          <DropdownMenuItem
            key={link.name}
            onClick={link.action}
            className="cursor-pointer gap-2"
          >
            <link.icon className="h-4 w-4" />
            {link.name}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
